import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatBorderRadiusCss = (borderRadius: string) => {
  if (borderRadius.includes("px") || borderRadius.includes("var")) {
    return borderRadius;
  }
  return `${borderRadius}px`;
};
